import type { CustomRequirement, RequirementReference } from '@gcv/shared';
import { CustomFieldType } from '@gcv/shared';

/** Pairs with a requirement id and a result id to update the responses for a specific result */
export const getUpdatedValues = (
  requirement: CustomRequirement & RequirementReference,
  resultId: string | undefined,
  formValues: Record<string, any>
): { [fieldId: string]: unknown } => {
  const fields = requirement?.custom_section?.fields ?? [];
  const updatedValues: Record<string, any> = {};
  for (const field of fields) {
    const formKey = requirement.custom_section.repeatable ? `${field.id}_${resultId}` : field.id;
    if (formValues[formKey] != null) {
      //empty, untouched checkbox fields return a value of false. we instead want a string as a list of semicolon separated checkbox options
      if (field.type === CustomFieldType.Checkbox && formValues[formKey] === false) continue;
      updatedValues[field.id] = formValues[formKey];
    }
  }
  return updatedValues;
};
